import {
  fetchClauseCheckDocumentsData,
  getKCCBatches,
  getKCCBatchDetails,
  getKCCAgenticFiles,
} from "../../services/contracts.service";
import { getUserTableData } from "../../modules/Admin/admin.service";
import {
  getChatSessionDetails,
  getContractsSyncData,
  getContractsSyncDetailsData,
  getExpiredContracts,
  getAboutToExpireContractsV2,
  getContractExecutionList,
} from "../../modules/vscDashboard/dashboard.service";
import {
  ClauseCheckAdvancedBatchTable,
  ClauseCheckAdvancedTable,
  ClauseCheckAgenticTable,
  ClauseCheckTable,
  ContractExpiryTable,
  ContractExpiryTableV2,
  ContractSyncDetailsTable,
  ContractSyncTable,
  TTCChatHistoryTable,
  UserManagementTable,
  VerticalDetailsTable,
  JobDetailsTable,
  ContractExecutionTable,
} from "./AntdTable.model";
import { getFiltersForKCC } from "./AntdTable.utils";
import { ContractTableData } from "../../modules/ManageContract/model";
import { getContractsForAntdTable, getVerticalArchivalJobs, getJobArchivalFiles } from "../../services/common.service";
import { ROUTES } from "../../common/constants";

export const DEFAULT_TABLE_PROPS = {
  PAGE: 1,
  PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: ["5", "10", "20", "50","100"],
};

export const ANTD_TABLE_ENTITIES = {
  KEY_CONTRACT_CLAUSES: "KEY_CONTRACT_CLAUSES",
  KEY_CONTRACT_CLAUSES_ADVANCED: "KEY_CONTRACT_CLAUSES_ADVANCED",
  KEY_CONTRACT_CLAUSES_ADVANCED_BATCH: "KEY_CONTRACT_CLAUSES_ADVANCED_BATCH",
  KEY_CONTRACT_CLAUSES_AGENTIC: "KEY_CONTRACT_CLAUSES_AGENTIC",
  USER_MANAGEMENT: "USER_MANAGEMENT",
  USER_MANAGEMENT_REQUESTS: "USER_MANAGEMENT_REQUESTS",
  USER_MANAGEMENT_REJECTED: "USER_MANAGEMENT_REJECTED",
  CONTRACT_EXPIRY: "CONTRACT_EXPIRY",
  CONTRACT_EXPIRY_V2: "CONTRACT_EXPIRY_V2",
  CONTRACTS_SYNC: "CONTRACTS_SYNC",
  CONTRACT_SYNC_DETAILS: "CONTRACT_SYNC_DETAILS",
  TTC_CHAT_HISTORY: "TTC_CHAT_HISTORY",
  CONTRACT_REDLINING_DASHBOARD: "CONTRACT_REDLINING_DASHBOARD",
  CONTRACT_REDLINING_PENDING: "review_pending",
  CONTRACT_REDLINING_COMPLETED: "review_completed",
  VERTICAL_DETAILS: "VERTICAL_DETAILS",
  JOB_DETAILS: "JOB_DETAILS",
  CONTRACT_EXECUTION: "CONTRACT_EXECUTION",
};

export const NO_TABLE_ENTITIES = [ANTD_TABLE_ENTITIES.TTC_CHAT_HISTORY];

export const entityDataMapper = {
  [ANTD_TABLE_ENTITIES.KEY_CONTRACT_CLAUSES]: {
    dataModel: ClauseCheckTable,
    columns: [],
    listApi: fetchClauseCheckDocumentsData,
    formatFilters: (filters: any, extras: any) => {
      const { clausesForVertical } = extras;
      const res = getFiltersForKCC(filters, clausesForVertical);
      return { filter: res };
    },
  },
  [ANTD_TABLE_ENTITIES.KEY_CONTRACT_CLAUSES_ADVANCED]: {
    dataModel: ClauseCheckAdvancedTable,
    columns: [],
    listApi: getKCCBatchDetails,
    formatFilters: (filters: any, extras: any) => {
      const { clausesForVertical } = extras;
      const res = getFiltersForKCC(filters, clausesForVertical);
      return { filter: res };
    },
  },
  [ANTD_TABLE_ENTITIES.KEY_CONTRACT_CLAUSES_ADVANCED_BATCH]: {
    dataModel: ClauseCheckAdvancedBatchTable,
    columns: [],
    listApi: getKCCBatches,
  },
  [ANTD_TABLE_ENTITIES.KEY_CONTRACT_CLAUSES_AGENTIC]: {
    dataModel: ClauseCheckAgenticTable,
    columns: [],
    listApi: getKCCAgenticFiles,
    formatFilters: (filters: any, extras: any) => {
      const { clausesForVertical } = extras;
      const res = getFiltersForKCC(filters, clausesForVertical);
      return { filter: res };
    },
  },

  [ANTD_TABLE_ENTITIES.USER_MANAGEMENT]: {
    dataModel: UserManagementTable,
    columns: [],
    defaultBodyProps: {
      status: ["manually_added", "approved"],
    },
    listApi: getUserTableData,
    formatFilters: (filters: any, extras: any) => {
      if (filters[3])
        return {
          is_active: filters[3][0],
        };
    },
  },
  [ANTD_TABLE_ENTITIES.USER_MANAGEMENT_REQUESTS]: {
    dataModel: UserManagementTable,
    columns: [],
    defaultBodyProps: {
      status: ["pending"],
    },
    listApi: getUserTableData,
  },
  [ANTD_TABLE_ENTITIES.USER_MANAGEMENT_REJECTED]: {
    dataModel: UserManagementTable,
    columns: [],
    defaultBodyProps: {
      status: ["rejected"],
    },
    listApi: getUserTableData,
  },
  [ANTD_TABLE_ENTITIES.CONTRACT_EXPIRY]: {
    dataModel: ContractExpiryTable,
    columns: [],
    listApi: getExpiredContracts,
    formatFilters: (filters: any, extras: any) => {
      if (filters[0])
        return {
          vendor_name: filters[0],
        };
    },
  },
  [ANTD_TABLE_ENTITIES.CONTRACT_EXPIRY_V2]: {
    dataModel: ContractExpiryTableV2,
    columns: [],
    listApi: getAboutToExpireContractsV2,
    formatFilters: (filters: any, extras: any) => {
      if (filters[0])
        return {
          vendor_name: filters[0],
        };
    },
  },
  [ANTD_TABLE_ENTITIES.CONTRACTS_SYNC]: {
    dataModel: ContractSyncTable,
    columns: [],
    listApi: getContractsSyncData,
  },
  [ANTD_TABLE_ENTITIES.CONTRACT_SYNC_DETAILS]: {
    dataModel: ContractSyncDetailsTable,
    columns: [],
    listApi: getContractsSyncDetailsData,
    formatFilters: (filters: any, extras: any) => {
      if (filters[5])
        return {
          filter: filters[5],
        };
    },
  },
  [ANTD_TABLE_ENTITIES.TTC_CHAT_HISTORY]: {
    dataModel: TTCChatHistoryTable,
    columns: [],
    listApi: getChatSessionDetails,
  },
  [ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_DASHBOARD]: {
    dataModel: ContractTableData,
    columns: [],
    listApi: getContractsForAntdTable,
    navigateTo: ROUTES.contractReviewDashboard,
  },
  [ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_PENDING]: {
    dataModel: ContractTableData,
    columns: [],
    listApi: getContractsForAntdTable,
    navigateTo: ROUTES.pendingReviewsRedlining,
  },
  [ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_COMPLETED]: {
    dataModel: ContractTableData,
    columns: [],
    listApi: getContractsForAntdTable,
    navigateTo: ROUTES.completeReviewsRedlining,
  },
  [ANTD_TABLE_ENTITIES.VERTICAL_DETAILS]: {
    dataModel: VerticalDetailsTable,
    columns: [],
    listApi: getVerticalArchivalJobs,
    formatFilters: (filters: any, extras: any) => {
      return {};
    },
  },
  [ANTD_TABLE_ENTITIES.JOB_DETAILS]: {
    dataModel: JobDetailsTable,
    columns: [],
    listApi: getJobArchivalFiles,
  },
  [ANTD_TABLE_ENTITIES.CONTRACT_EXECUTION]: {
    dataModel: ContractExecutionTable,
    columns: [],
    listApi: getContractExecutionList,
    formatFilters: (filters: any) => {
      const supplierFilter = filters?.[0] || filters?.supplierEntity;
      if (!supplierFilter) return;
      return {
        supplier_entity: supplierFilter,
      };
    },
  },
};

export const SCREEN_STATUS = {
  DATA: "DATA",
  NO_DATA: "NO_DATA",
  ERROR: "ERROR",
  ID_ERROR: "ID_ERROR",
  LOADING: "LOADING",
  IN_PROGRESS: "IN_PROGRESS",
};

export const ColumnFilter = {
  AVAILABLE: "Clause available",
  NOT_AVAILABLE: "Clause not available",
};

export const USER_REQUEST = {
  APPROVE: "Approve",
  REJECT: "Reject",
};

export const EMAIL_VALIDATION_ERROR = {
  EMPTY: "Email ID is required.",
  INVALID: "Please enter a valid email address.",
};

export const SYNC_JOB_STATUS = {
  COMPLETED: "COMPLETED",
  IN_PROGRESS: "IN_PROGRESS",
  FAILED: "FAILED",
};

export const SYNC_JOB_FILE_STATUS = {
  MOVED: "FILE_MOVED",
  NOT_MOVED: "FILE_NOT_MOVED",
  FAILED: "CHECK_FAILED",
};

export const SYNC_JOB: {
  [key: string]: {
    CSS_CLASS: string;
    LABEL: string;
  };
} = {
  [SYNC_JOB_STATUS.COMPLETED]: {
    CSS_CLASS: "completed",
    LABEL: "Synced",
  },
  [SYNC_JOB_STATUS.IN_PROGRESS]: {
    CSS_CLASS: "in_progress",
    LABEL: "Syncing",
  },
  [SYNC_JOB_STATUS.FAILED]: {
    CSS_CLASS: "failed",
    LABEL: "Failed",
  },
};

export const SYNC_FILE: {
  [key: string]: {
    CSS_CLASS: string;
    LABEL: string;
  };
} = {
  [SYNC_JOB_FILE_STATUS.MOVED]: {
    CSS_CLASS: "completed",
    LABEL: "Moved",
  },
  [SYNC_JOB_FILE_STATUS.NOT_MOVED]: {
    CSS_CLASS: "not_moved",
    LABEL: "Not Moved",
  },
  [SYNC_JOB_FILE_STATUS.FAILED]: {
    CSS_CLASS: "failed",
    LABEL: "Failed",
  },
};

export const navigatingRouteFor = (key?: string) => {
  switch (key) {
    case ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_DASHBOARD:
      return ROUTES.contractReviewDashboard;

    case ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_PENDING:
      return ROUTES.pendingReviewsRedlining;

    case ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_COMPLETED:
      return ROUTES.completeReviewsRedlining;

    default:
      return ROUTES.contractReviewDashboard;
  }
};
